// Loads a sprite image and removes magenta (#FF00FF) chroma-key background,
// returning an HTMLCanvasElement that can be drawn on a canvas.
// Result is cached per src.
const cache = new Map();

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = src;
  });

export const loadChromaKeySprite = async (src) => {
  if (cache.has(src)) return cache.get(src);
  const img = await loadImage(src);
  const c = document.createElement("canvas");
  c.width = img.naturalWidth;
  c.height = img.naturalHeight;
  const ctx = c.getContext("2d");
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(img, 0, 0);
  const data = ctx.getImageData(0, 0, c.width, c.height);
  const p = data.data;
  for (let i = 0; i < p.length; i += 4) {
    const r = p[i], g = p[i + 1], b = p[i + 2];
    // Magenta-ish range: high red, low green, high blue
    if (r > 200 && g < 90 && b > 200) {
      p[i + 3] = 0;
    }
  }
  ctx.putImageData(data, 0, 0);
  cache.set(src, c);
  return c;
};
